import React, { useContext, useState } from 'react';
import { Badge, Flex, theme } from 'antd';

import QueueDetails from '@totem/components/ticketing/queueTotals/QueueDetails';
import QueueTotalsContext from '@totem/components/ticketing/queueTotals/QueueTotalsContext';
import IBTabs from '@totem/components/ui_components/antDesignOverrides/IBTabs';
import { isNull } from '@totem/utilities/common';

import './queueTabs.css';

const QueueTabs = () => {
  const { data } = useContext(QueueTotalsContext);
  const { token } = theme.useToken();
  const [selectedKey, setSelectedKey] = useState<string>('');

  // Default to the first queue until one is picked, or if the picked queue
  // drops out of the data on refresh.
  const activeKey =
    !isNull(data) && data.some((queue) => queue.queueID === selectedKey)
      ? selectedKey
      : (data?.[0]?.queueID ?? '');

  return (
    <div styleName="queue-tabs">
      <IBTabs
        tabPlacement="start"
        activeKey={activeKey}
        onChange={setSelectedKey}
        items={
          isNull(data)
            ? []
            : data.map((queue) => {
                return {
                  key: queue.queueID,
                  label: (
                    <Flex
                      justify="space-between"
                      align="center"
                      gap={12}
                      style={{ width: '100%' }}
                    >
                      <span>{queue.queueName}</span>
                      <Badge
                        count={queue.ticketCount}
                        overflowCount={9999}
                        style={
                          queue.queueID === activeKey
                            ? undefined
                            : {
                                backgroundColor: token.colorFillSecondary,
                                color: token.colorTextSecondary,
                              }
                        }
                      />
                    </Flex>
                  ),
                  children: (
                    <QueueDetails
                      queueId={queue.queueID}
                      queueName={queue.queueName}
                    />
                  ),
                };
              })
        }
      />
    </div>
  );
};

export default QueueTabs;
